<nz-skeleton [nzLoading]="loading$ | async" [nzActive]="true" [nzParagraph]="{ rows: 5 }">
  <ng-container *ngIf="inspectionData.requestExists; else createRequestForm">
    <ng-container *ngIf="inspectionData.requestCompleted === false">
      <nz-alert
        *ngIf="inspectionData.isForCurrentUser"
        [nzMessage]="'WATCH_REQUEST.ALREADY_CREATED' | translate"
      ></nz-alert>

      <nz-alert *ngIf="inspectionData.isForCurrentUser === false" [nzMessage]="alertContent">
        <ng-template #alertContent>
          <div [innerHTML]="'WATCH_REQUEST.ADDITIONAL_WATCH_REQUEST_TYPE.TITLE' | translate"></div>
          <div
            [innerHTML]="
                  'WATCH_REQUEST.ADDITIONAL_WATCH_REQUEST_TYPE.PRICE' | translate: { price: price$ | async | number }
              ">
          </div>
          <div [innerHTML]="'WATCH_REQUEST.ADDITIONAL_WATCH_REQUEST_TYPE.END' | translate"></div>
        </ng-template>
      </nz-alert>
    </ng-container>
  </ng-container>

  <ng-template #createRequestForm>
    <section>
      <nz-alert [nzMessage]="alertContent">
        <ng-template #alertContent>
          <div [innerHTML]="'WATCH_REQUEST.ALERT_START_LINE' | translate"></div>
          <div>
            <span
              [innerHTML]="
                'WATCH_REQUEST.ALERT_BASE_PRICE' | translate: { price: price$ | async | number }
              "
            ></span>
          </div>
          <div [innerHTML]="'WATCH_REQUEST.ALERT_END_LINE' | translate"></div>
        </ng-template>
      </nz-alert>
    </section>

    <section>
      <nz-alert
        *ngIf="timeLimitReached$ | async; else commentForm"
        nzType="warning"
        [nzMessage]="
          'WATCH_REQUEST.TIME_LIMIT_REACHED'
            | translate
              : {
                  before: auctionData.inspectionAvailableBeforeHours,
                  after: auctionData.inspectionAfterEndUntilTimeJst
                }
        "
      ></nz-alert>
      <ng-template #commentForm>
        <form nz-form [formGroup]="form" nzLayout="vertical">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="commentErrorsTxt">
              <nz-textarea-count
                [nzMaxCharacterCount]="commentLimit"
                [nzComputeCharacterCount]="computeLength"
              >
                <textarea
                  nz-input
                  formControlName="comment"
                  [rows]="4"
                  [placeholder]="'WATCH_REQUEST.COMMENT' | translate"
                ></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>
        </form>
        <ng-template #commentErrorsTxt let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'WATCH_REQUEST.ERROR_COMMENT' | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('maxlength')">
            {{ 'WATCH_REQUEST.WARNING_COMMENT' | translate }}
          </ng-container>
        </ng-template>
      </ng-template>
    </section>
  </ng-template>
</nz-skeleton>

<ng-container *nzModalFooter>
  <button
    *ngIf="inspectionData.requestExists === false"
    nz-button
    nzType="primary"
    [disabled]="form.invalid"
    [nzLoading]="creating$ | async"
    (click)="createRequest()"
  >
    {{ 'WATCH_REQUEST.SEND' | translate }}
  </button>
  <button
    *ngIf="inspectionData.requestExists && inspectionData.requestCompleted === false && inspectionData.isForCurrentUser === false"
    nz-button
    nzType="primary"
    [nzLoading]="creating$ | async"
    (click)="createRequest(true)"
  >
    {{ 'WATCH_REQUEST.ORDER' | translate }}
  </button>
  <button nz-button (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
</ng-container>
